import '../css/index.less';
import DPlayer from './player';
console.log('\n'.concat(' %c 1450TV播放器', DPLAYER_VERSION, ' ').concat(GIT_HASH, ' %c http://www.1450tv.com ', '\n', '\n'), 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
export default DPlayer;